import { useUserTour } from '@/shared/hooks';
import { UserTourSectionEnum } from '@/shared/types/graphql/globals';

const useSavedCoursesUserDashTour = ({ skip }: { skip: boolean }) =>
  useUserTour({
    section: UserTourSectionEnum.USER_DASHBOARD_SAVED_COURSES,
    skip,
  });

export default useSavedCoursesUserDashTour;
